import React, {PropTypes} from 'react';
import { FormattedMessage } from 'react-intl';

import Modal from 'routes/app/components/Modal';
import Input from 'routes/app/components/Input';
import Button from 'routes/app/components/Button';
import Select from 'routes/app/components/Select';
import Row from 'routes/app/components/Row';


const GoodsDetailModal = ({translate, children, packUnity, showHazardous, onClickAgree, onClickDisagree, fields:{
    desc, nettoWeight, packagingId, packagingCount, packagingUnity, colliId,
    hzd, id, hzdData }}) => {

    const AgreeEl = (<div>
            <Button onClick={onClickAgree} waves="light" modal="close" flat>{translate({id:'unit.button.saveAndClose'})}</Button>
            <Button onClick={onClickAgree} waves="light" flat>{translate({id:'unit.goods.modal.submit'})}</Button>
    </div>);

    return (
        <Modal
            trigger={children}
            onClickAgree={onClickAgree}
            onClickDisagree={onClickDisagree}
            header={translate({id:'unit.goods.modal.header'})}
            textDisagree={onClickAgree ? translate({id:'unit.goods.modal.close'}) : translate({id:'unit.goods.modal.edit'})}
            agreeElement={onClickAgree && AgreeEl}
            closeOnAgree={false}
            className="form-modal"
        >
            <Row>
                <Input s={12} label={translate({id:'good.label.description'})} type="textarea" {...desc} error={desc.error && translate({id:desc.error.transId}, desc.error.values)} />
                <Input s={6} m={3} label={translate({id:'good.label.netWeight'})} {...nettoWeight} error={nettoWeight.error && translate({id:nettoWeight.error.transId}, nettoWeight.error.values)}  />
                <Input s={6} m={4} label={translate({id:'good.label.colliID'})} {...colliId} error={colliId.error && translate({id:colliId.error.transId}, colliId.error.values)} />
                <Input s={12} m={6} label={translate({id:'good.label.packagingID'})} {...packagingId} error={packagingId.error && translate({id:packagingId.error.transId}, packagingId.error.values)} />
                <Input s={8} m={4} label={translate({id:'good.label.packagingCount'})} {...packagingCount} error={packagingCount.error && translate({id:packagingCount.error.transId}, packagingCount.error.values)} />
                <Select s={4} m={2} label={translate({id:'good.label.numPackIdUnit'})}
                        options={packUnity} optionValue="code" optionLabel="desc"
                        {...packagingUnity} />
            </Row>

            {showHazardous &&
            <div className="goods__hazardous">
                <Row>
                    <Input s={12} m={12} label={translate({id:'good.label.hazardous'})} type="checkbox" className="filled-in" {...hzd} checked={hzd.value || false} />
                </Row>
                {hzd.value ? <Row>

                    <Input s={12} type="select" {...hzdData.ridReg}>
                        <option value="ADR">ADR</option>
                        <option value="IMD">IMD</option>
                        <option value="RID">RID</option>
                    </Input>

                    {/* //TODO: find out why this doesn't work
                    <Input s={6} m={4}  type="radio" name="rid" className="with-gap"
                            label="ADR"
                        {...hzdData.ridReg} value="ADR" checked={hzdData.ridReg.value === 'ADR'} />

                    <Input s={6} m={4}  type="radio" name="rid" className="with-gap"
                           label="IMCO"
                        {...hzdData.ridReg} value="IMCO" checked={hzdData.ridReg.value === 'IMCO'} />

                    <Input s={6} m={4}  type="radio" name="rid" className="with-gap"
                           label="RID"
                        {...hzdData.ridReg} value="RID" checked={hzdData.ridReg.value === 'RID'} />*/}

                    <Input s={6} label={translate({id:'good.label.id'})} {...hzdData.ridId} error={hzdData.ridId.error && translate({id:hzdData.ridId.error.transId}, hzdData.ridId.error.values)} />
                    <Input s={6} label={translate({id:'good.label.unnr'})} {...hzdData.unNr} error={hzdData.unNr.error && translate({id:hzdData.unNr.error.transId}, hzdData.unNr.error.values)} />
                    <Input s={6} label={translate({id:'good.label.cls'})} {...hzdData.cls} error={hzdData.cls.error && translate({id:hzdData.cls.error.transId}, hzdData.cls.error.values)}  />
                    <Input s={6} label={translate({id:'good.label.packingGroup'})} {...hzdData.packingGroup} error={hzdData.packingGroup.error && translate({id:hzdData.packingGroup.error.transId}, hzdData.packingGroup.error.values)} />
                    <Input s={12} label={translate({id:'good.label.limitedQuantities'})} type="checkbox" className="filled-in" {...hzdData.lq} checked={hzdData.lq && (hzdData.lq.value === 1 || hzdData.lq.value)} />
                    <Input s={12} label={translate({id:'good.label.maritime'})} type="checkbox" className="filled-in" {...hzdData.maritime} checked={hzdData.maritime && (hzdData.maritime.value === 1 || hzdData.maritime.value)} />
                    <Input s={12} label={translate({id:'good.label.env'})} type="checkbox" className="filled-in" {...hzdData.environment} checked={hzdData.environment && (hzdData.environment.value === 1 || hzdData.environment.value)} />
                    <Input s={12} label={translate({id:'good.label.waste'})} type="checkbox" className="filled-in" {...hzdData.waste} checked={hzdData.waste && (hzdData.waste.value === 1 || hzdData.waste.value)} />
                </Row> : null}
            </div>
            }
            <Input type="hidden" {...id} />
            <Input type="hidden" {...hzdData.originalHzdId} />
            <Input type="hidden" {...hzdData.hzdId} />
        </Modal>
    );
};

GoodsDetailModal.propTypes = {
    children: PropTypes.node,
    onClickAgree: PropTypes.func,
    onClickDisagree: PropTypes.func,
    fields: PropTypes.object,
    packUnity: React.PropTypes.array,
    showHazardous: React.PropTypes.bool,
    translate: PropTypes.func
};

export default GoodsDetailModal;